import { render, staticRenderFns } from "./CampaignHistory.vue?vue&type=template&id=1af02716&scoped=true&"
import script from "./CampaignHistory.vue?vue&type=script&lang=js&"
export * from "./CampaignHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af02716",
  null
  
)

export default component.exports